module.exports = __webpack_public_path__ + "img/fiolettop.63acc4c3.png";